<div class="month-stepper">
  <button type="button" class="stepper-btn" [matTooltip]="'Previous month' | translate" (click)="step.emit(-1)">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <span class="month-label">{{ label }}</span>
  <button type="button" class="stepper-btn" [matTooltip]="'Next month' | translate"
    [disabled]="!canStepForward" (click)="step.emit(1)">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
